// ============================================================
// Highlights.js - Key Highlights section with tick cards
// ============================================================

import React from "react";
import { HIGHLIGHTS } from "../data";

function Highlights() {
  return (
    <section className="highlights" id="highlights">
      <h2>Key Highlights</h2>

      <div className="highlights-grid">
        {HIGHLIGHTS.map((item) => (
          <div className="highlight-card" key={item}>
            <div className="check-icon" style={{ border: 'none', background: 'transparent', padding: 0 }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0d9b8e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="8 12 11 15 16 9"></polyline></svg>
            </div>
            <span>{item}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Highlights;
